import React from 'react';
import { motion } from 'framer-motion';

const TextReveal = ({
  text,
  as: Tag = 'h2',
  mode = 'word',
  stagger = 0.08,
  delay = 0,
  className = '',
  once = true,
}) => {
  const units = mode === 'char' ? text.split('') : text.split(' ');

  const container = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: stagger,
        delayChildren: delay,
      },
    },
  };

  const child = {
    hidden: {
      opacity: 0,
      y: 20,
      clipPath: 'inset(0 0 100% 0)',
    },
    visible: {
      opacity: 1,
      y: 0,
      clipPath: 'inset(0 0 0% 0)',
      transition: {
        duration: 0.5,
        ease: [0.25, 0.46, 0.45, 0.94],
      },
    },
  };

  const MotionTag = motion[Tag] || motion.h2;

  return (
    <MotionTag
      className={`${className}`}
      variants={container}
      initial="hidden"
      whileInView="visible"
      viewport={{ once, amount: 0.3 }}
    >
      {units.map((unit, i) => (
        <motion.span
          key={i}
          variants={child}
          style={{ display: 'inline-block', willChange: 'transform, opacity' }}
        >
          {unit}
          {mode === 'word' && i < units.length - 1 ? '\u00A0' : ''}
        </motion.span>
      ))}
    </MotionTag>
  );
};

export default TextReveal;
